import { Input, message } from 'antd';
import { useRef, useState } from 'react';

import Button from '@/components/common/Button';
import { UseTranslateType } from '@/hooks/useTranslate';
import { checkLogin, checkNewOldPassword, updatePassword } from '@/services/login';
import useLoginStore from '@/store/Login';
import { ciphertext, getCookie, passwordReg } from '@/utils';

import CommonModal, { ForgetPasswordModal } from '..';
import CloseIcon from '../icon/close';
import styles from './style.module.scss';

interface ContentProps {
  t: UseTranslateType;
  hasPwd: boolean;
  destroyHandler: any;
  onClose: () => void;
}
const TipIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 10.6V7.35M8 5.01V5M14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C4.54822 14.25 1.75 11.4518 1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8Z"
      stroke="#8BA2CC"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
const EyeVisible = (
  props: React.SVGProps<SVGSVGElement> & { onClick?: React.MouseEventHandler },
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    onClick={props.onClick}
  >
    <path
      d="M16.5939 8.96325C16.1879 8.19157 15.6676 7.4902 15.04 6.87321C14.9574 6.79059 14.8713 6.71149 14.7834 6.63063L16.6836 5.4195C16.9473 5.2525 17.0246 4.9027 16.8541 4.63903C16.6871 4.37535 16.3373 4.29801 16.0736 4.46852L13.843 5.8941C13.3631 5.56715 12.848 5.28942 12.3031 5.06266C12.0078 4.94137 11.7107 4.83414 11.4066 4.7445L12.3101 2.39957C12.4209 2.10778 12.2767 1.78082 11.985 1.66832C11.6932 1.55758 11.3662 1.70172 11.2537 1.99352L10.2904 4.49664C9.89491 4.43688 9.49237 4.40348 9.08983 4.39821C8.64159 4.39293 8.19862 4.42282 7.76093 4.4861L6.76776 1.8986C6.65702 1.6068 6.32831 1.46266 6.03651 1.5734C5.74472 1.68414 5.60058 2.01286 5.71132 2.30465L6.64647 4.72868C6.3494 4.81481 6.05761 4.91676 5.76933 5.03629C5.21034 5.26832 4.68124 5.55309 4.18905 5.89059L1.98827 4.48434C1.7246 4.31735 1.37479 4.39293 1.2078 4.65485C1.04081 4.91852 1.1164 5.26832 1.37831 5.43532L3.25214 6.63063C3.16073 6.71325 3.07284 6.79938 2.98319 6.88727C2.36972 7.49899 1.85995 8.19157 1.45917 8.95094C1.21483 9.415 1.21483 9.92477 1.45917 10.3888C1.86522 11.1605 2.38554 11.8619 3.01308 12.4789C3.80058 13.2541 4.71991 13.8623 5.74823 14.2912C6.77655 14.7183 7.85585 14.9433 8.96151 14.9556C10.1076 14.9697 11.2256 14.7535 12.2855 14.3175C13.335 13.8869 14.2701 13.2629 15.0717 12.463C15.6851 11.8531 16.1949 11.1623 16.5939 10.4029C16.8383 9.93707 16.8383 9.42731 16.5939 8.96325ZM11.8531 13.2664C8.53964 14.6322 4.7955 13.4088 2.87421 10.5382C2.51737 10.0056 2.51913 9.34645 2.87772 8.81559C3.68983 7.60973 4.85175 6.64821 6.20526 6.09274C9.51874 4.72692 13.2629 5.95036 15.1824 8.82086C15.5392 9.35348 15.5375 10.0127 15.1789 10.5453C14.3668 11.7476 13.2049 12.7074 11.8531 13.2664Z"
      fill="#bbb"
    />
    <path
      d="M9.06016 6.32422C7.18984 6.32422 5.67285 7.84121 5.67285 9.71152C5.67285 11.5818 7.18984 13.0988 9.06016 13.0988C10.9305 13.0988 12.4492 11.5836 12.4492 9.71328C12.4475 7.84297 10.9322 6.32422 9.06016 6.32422ZM10.6562 11.3076C10.2309 11.733 9.66484 11.9686 9.06016 11.9686C8.45547 11.9686 7.89121 11.733 7.46406 11.3076C7.03867 10.8822 6.80312 10.3162 6.80312 9.71152C6.80312 9.10684 7.03867 8.54258 7.46406 8.11543C7.88945 7.69004 8.45547 7.45449 9.06016 7.45449C9.66484 7.45449 10.2291 7.69004 10.6562 8.11543C11.0816 8.54082 11.3172 9.10684 11.3172 9.71152C11.3172 10.3145 11.0834 10.8822 10.6562 11.3076Z"
      fill="#bbb"
    />
  </svg>
);

const EyeUnvisible = (
  props: React.SVGProps<SVGSVGElement> & { onClick?: React.MouseEventHandler },
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className="cursor-pointer select-none"
    onClick={props.onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75482 2.01867C2.94912 2.01524 3.13717 2.08737 3.27934 2.21985L4.81934 3.75985C5.71202 3.30544 6.69179 3.04782 7.69252 3.00439C8.69326 2.96095 9.69167 3.13269 10.6204 3.50804C11.5491 3.88338 12.3864 4.45359 13.0759 5.18017C13.7655 5.90675 14.2911 6.77279 14.6173 7.71985C14.6807 7.90354 14.6807 8.10315 14.6173 8.28685C14.1962 9.50198 13.4489 10.5779 12.4573 11.3968L13.7793 12.7198C13.853 12.7885 13.9121 12.8713 13.9531 12.9633C13.9941 13.0553 14.0162 13.1546 14.0179 13.2553C14.0197 13.356 14.0012 13.4561 13.9635 13.5494C13.9257 13.6428 13.8696 13.7277 13.7984 13.7989C13.7272 13.8701 13.6423 13.9262 13.5489 13.964C13.4556 14.0017 13.3555 14.0202 13.2548 14.0184C13.1541 14.0167 13.0548 13.9946 12.9628 13.9536C12.8708 13.9126 12.788 13.8535 12.7193 13.7798L2.21934 3.27985C2.08686 3.13767 2.01474 2.94963 2.01817 2.75532C2.0216 2.56102 2.10031 2.37564 2.23772 2.23822C2.37513 2.10081 2.56052 2.0221 2.75482 2.01867ZM7.61034 6.55085L6.47534 5.41485H6.47634C7.04938 5.07621 7.71875 4.93776 8.3791 5.0213C9.03945 5.10483 9.65327 5.4056 10.1239 5.87626C10.5946 6.34692 10.8954 6.96074 10.9789 7.62109C11.0624 8.28144 10.924 8.95081 10.5853 9.52385L9.44934 8.38885C9.51719 8.13433 9.51692 7.86646 9.44855 7.61208C9.38018 7.35771 9.24612 7.12579 9.05981 6.93959C8.87351 6.75339 8.64152 6.61945 8.38711 6.55122C8.1327 6.48299 7.86482 6.48286 7.61034 6.55085ZM9.62735 12.8098L7.81135 10.9938C7.08216 10.948 6.39475 10.6377 5.87812 10.1211C5.36149 9.60444 5.05116 8.91703 5.00535 8.18785L2.49235 5.67485C2.01014 6.28762 1.63394 6.97682 1.37935 7.71385C1.31626 7.89724 1.31626 8.09645 1.37935 8.27985C1.94601 9.92442 3.10445 11.2992 4.6291 12.1366C6.15375 12.974 7.93548 13.214 9.62735 12.8098Z"
      fill="#bbb"
    />
  </svg>
);
const Title = ({ t, hasPwd, onClose }: Omit<ContentProps, 'salt' | 'destroyHandler'>) => (
  <div>
    <span className="text-[24px] text-[#000] font-sans font-[700] leading-[32px] select-none">
      {hasPwd ? t('Change-Password') : t('Set-Password')}
    </span>
    <div className="absolute top-[16px] right-[16px] cursor-pointer" onClick={onClose}>
      <CloseIcon />
    </div>
  </div>
);

const Desc = ({ t }: { t: UseTranslateType }) => (
  <div className="mb-[24px] select-none mt-[20px]">
    <div className="flex items-center text-[#000] gap-[6px]">
      {TipIcon}
      <span className="font-[16px] leading-[24px]">
        {t('Change-Password-requirements')}
      </span>
    </div>
    <div className="list-disc text-[#000] pl-[4px] text-[12px] leading-[16px]">
      {[t('bc.pwd.desc-1'), t('bc.pwd.desc-2')].map((item, index) => {
        return (
          <div key={index} className="flex items-start gap-[8px]">
            <div className="w-[5px] h-[5px] rounded-full bg-[#5D7AB3] shrink-0 mt-[6px]"></div>
            <div>{item}</div>
          </div>
        );
      })}
    </div>
  </div>
);

const Content = ({ t, hasPwd = true, destroyHandler, onClose }: ContentProps) => {
  const [oldValue, setOldValue] = useState<string>('');
  const [newValue, setNewValue] = useState<string>('');
  const [confirmValue, setConfirmValue] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const passwordValidate = {
    newAndOldNotSame(oldValue: string, newValue: string) {
      if (newValue === oldValue) {
        message.error(t('Change-Password-Tip-4'));
        return false;
      }
      return true;
    },
    newAndConfirmSame(newValue: string, confirmValue: string) {
      if (newValue !== confirmValue) {
        message.error(t('Change-Password-Tip-2'));
        return false;
      }
      return true;
    },
    newValueValid(newValue: string) {
      if (!passwordReg(newValue)) {
        message.error(t('Change-Password-Tip-3'));
        return false;
      }
      return true;
    },
  };

  const setPwdFn = async (password: string, accountId: string) => {
    if (!passwordValidate.newAndConfirmSame(newValue, confirmValue)) return;
    if (!passwordValidate.newValueValid(newValue)) return;

    const { salt, newPassword } = await ciphertext('', password);

    const res = await updatePassword({
      accountId: accountId,
      salt,
      newPassword,
    });
    if (res.code === 200) {
      message.success(t('Set-Password-Successful'));
      onClose();
    } else {
      message.error(res.msg || t('Set-Password-Fail'));
    }
  };

  const updatePwdFn = async (accountId: string) => {
    const checkLoginRes = await checkLogin({
      accountId,
      accountType: 65,
    });
    const { salt: oldSalt } = checkLoginRes.data;

    const { oldPassword: oldPasswordCrypto } = await ciphertext(oldSalt, oldValue);
    const { salt: newSalt, newPassword: newPasswordCrypto } = await ciphertext(
      '',
      newValue,
    );

    if (!passwordValidate.newAndConfirmSame(newValue, confirmValue)) return;
    if (!passwordValidate.newAndOldNotSame(oldValue, newValue)) return;
    if (!passwordValidate.newValueValid(newValue)) return;

    const checkRes = await checkNewOldPassword({
      accountId,
      oldPassword: oldPasswordCrypto,
      newPassword: newPasswordCrypto,
      salt: newSalt,
    });
    if (checkRes?.data?.code === 10103013) {
      return message.error(t('Change-Password-Tip-1'));
    }

    if (checkRes.success && checkRes.code === 200) {
      message.success(t('Change-Password-Changed-Successfully'));
      onClose();
      setTimeout(() => {
        useLoginStore.getState().logout();
        window.location.href = window.location.origin + '/home';
      }, 500);
    } else {
      message.error(checkRes.msg || t('Change-Password-Changed-Failed'));
    }
  };

  const handleClick = async () => {
    try {
      setLoading(true);
      const accountId = getCookie('user')?.accountId;
      if (!accountId) {
        return;
      }
      if (hasPwd) {
        await updatePwdFn(accountId);
      } else {
        await setPwdFn(newValue, accountId);
      }
    } catch (error) {
      message.error(
        hasPwd ? t('Change-Password-Changed-Failed') : t('Set-Password-Fail'),
      );
    } finally {
      setLoading(false);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };
  return (
    <div
      className="px-[60px] pt-[48px] pb-[52px] relative"
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <Title t={t} onClose={onClose} hasPwd={hasPwd} />

      <div className="flex gap-[16px] flex-col pt-[28px] pb-[6px]">
        {hasPwd && (
          <Input.Password
            className={styles['change-password-input']}
            placeholder={t('Change-Password-2')}
            value={oldValue}
            onChange={(e) => {
              const value = e.target.value;
              setOldValue(value);
            }}
            iconRender={(visible) => (visible ? <EyeVisible /> : <EyeUnvisible />)}
          />
        )}
        <Input.Password
          className={styles['change-password-input']}
          placeholder={t('Change-Password-0')}
          value={newValue}
          onChange={(e) => {
            const value = e.target.value;
            setNewValue(value);
          }}
          iconRender={(visible) => (visible ? <EyeVisible /> : <EyeUnvisible />)}
        />

        <Input.Password
          className={styles['change-password-input']}
          placeholder={t('Change-Password-1')}
          value={confirmValue}
          onChange={(e) => {
            const value = e.target.value;
            setConfirmValue(value);
          }}
          iconRender={(visible) => (visible ? <EyeVisible /> : <EyeUnvisible />)}
        />
      </div>
      {hasPwd && (
        <p
          className="text-[#000] text-[12px] text-right cursor-pointer"
          onClick={() => {
            destroyHandler.current?.();
            ForgetPasswordModal.show();
          }}
        >
          {t('merror.login.password.forget')}
        </p>
      )}
      <Desc t={t} />
      <Button
        className="w-full !py-[8px] !text-[18px] !leading-[28px]"
        loading={loading}
        disabled={!newValue || !confirmValue}
        onClick={handleClick}
      >
        {t('merror.operate.confirm')}
      </Button>
    </div>
  );
};

export function useChangePasswordModal() {
  const destroyHandler = useRef<(() => void) | null>(null);

  const showModal = (options: { hasPwd: boolean; onClose?: () => void }) => {
    CommonModal.show(
      (t) => ({
        width: 480,
        customPadding: {
          x: 0,
          y: 0,
        },
        footer: false,
        content: (close) => (
          <Content
            t={t}
            hasPwd={options.hasPwd}
            destroyHandler={destroyHandler}
            onClose={() => {
              close();
              options.onClose?.();
            }}
          />
        ),
      }),
      destroyHandler,
    );
  };

  return { showModal, destroyHandler };
}
